import Checklists from 'features/policySingle/components/legacy/checklists';

export const PolicyChecklists = () => {
  return <Checklists policySingleV2 />;
};
